import { render, staticRenderFns } from "./characterStory.vue?vue&type=template&id=2bcce2ae&scoped=true"
import script from "./characterStory.vue?vue&type=script&lang=js"
export * from "./characterStory.vue?vue&type=script&lang=js"
import style0 from "./characterStory.vue?vue&type=style&index=0&id=2bcce2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcce2ae",
  null
  
)

export default component.exports